import React from 'react';
import { CircleHelp, Trophy } from 'lucide-react';
import AirdropPointsTable from './AirdropPointsTable';

function Leaderboards() {
  return (
    <div className="data-page">
      <section className="page-intro">
        <div className="content-width page-intro-inner">
          <div>
            <div className="eyebrow"><Trophy size={17} aria-hidden="true" /> Holder points</div>
            <h1>Points leaderboard</h1>
            <p>See who is leading the daily holder race and find any ranked wallet.</p>
          </div>
          <div className="headline-stat headline-stat-copy">
            <strong>Hold. Earn. Climb.</strong>
            <span>Two points per Pepe, every day.</span>
          </div>
        </div>
      </section>
      <section className="data-section content-width">
        <AirdropPointsTable />
      </section>
      <section className="rules-section">
        <div className="content-width rules-grid">
          <div>
            <div className="eyebrow eyebrow-dark"><CircleHelp size={17} aria-hidden="true" /> How it works</div>
            <h2>Keep your Pepes. Build your score.</h2>
          </div>
          <ol className="rules-list">
            <li><span>01</span><div><strong>Daily earned</strong><p>Every active wallet earns two points per held Pepe at the daily snapshot.</p></div></li>
            <li><span>02</span><div><strong>Collection adjustment</strong><p>Adding Pepes applies the established acquisition bonus before daily points are added.</p></div></li>
            <li><span>03</span><div><strong>Sale adjustment</strong><p>Reducing a holding applies the established sale penalty. The adjustment is shown separately from daily earnings.</p></div></li>
          </ol>
        </div>
      </section>
    </div>
  );
}

export default Leaderboards;
